import angular from "angular";
import { configureStates } from "../../core/router/router-helper.provider";

const routes = [{
    state: "admin",
    config: {
        url: "/admin",
        abstract: true,
        data: {
            permissionKey: "navigation:securityGroups"
        }
    }
},
{
    state: "admin.role",
    config: {
        url: "/roles",
        redirectTo: "admin.role.list"
    }
},
{
    state: "security.listRoles",
    config: {
        url: "^/security/listRoles",
        redirectTo: "admin.role.list"
    }
},
{
    state: "admin.claim",
    config: {
        url: "/claims",
        redirectTo: "admin.claim.list"
    }
},
{
    state: "admin.claim.list",
    config: {
        component: "apexIdentityClaimsList",
        data: {
            pageHeader: "Special Claims Index"
        }
    }
},
{
    state: "admin.role.list",
    config: {
        component: "apexRoleList",
        resolve: {
            roleList: roleService => {
                'ngInject';
                return roleService.retrieveV2Roles();
            }
        },
        data: {
            pageHeader: "Roles"
        }
    }
},
{
    state: "admin.role.edit",
    config: {
        url: "/:roleID",
        component: "apexEditRole",
        resolve: {
            role: (roleService, $transition$) => {
                'ngInject';
                const { roleID } = $transition$.params();
                return roleService.retrieveV2Role(roleID);
            },
            divisions: (divisionService) => {
                'ngInject';
                return divisionService.retrieveDivisions();
            }
        },
        data: {
            pageHeader: "Edit Role"
        }
    }
},
{
    state: "admin.role.create",
    config: {
        url: "/new",
        component: "apexEditRole",
        resolve: {
            role: () => {
                'ngInject';
                return {
                    Claims: [],
                    Divisions: [],
                    MinPositionsFilled: 0,
                    GrantType: 'GrantAll'
                }
            },
            divisions: (divisionService) => {
                'ngInject';
                return divisionService.retrieveDivisions();
            }
        },
        data: {
            pageHeader: "Create Role"
        }
    }
},
{
    state: "admin.claim.edit",
    config: {
        url: "/:claimType/:claimValue/permissions",
        component: "apexEditClaim",
        params: {
            claimValue: { squash: true, value: "" }
        },
        resolve: {
            claimValues: ($transition$) => {
                'ngInject';
                const { claimType, claimValue } = $transition$.params();
                return { claimType: atob(claimType), claimValue: claimValue === "-" ? "" : claimValue };
            },
            claimPermissionList: (permissionGrantService, claimValues) => {
                'ngInject';
                const { claimType, claimValue } = claimValues;
                return permissionGrantService.getClaimPermissionGrants(claimType, claimValue);
            },
            permissionDescriptions: permissionGrantService => {
                'ngInject';
                return permissionGrantService.retrievePermissionDescriptions();
            }
        },
        data: {
            pageHeader: "Claim Permissions"
        }
    }
},
{
    state: "admin.permissions",
    config: {
        url: "/permissions",
        component: "apexPermissionList",
        resolve: {
            claimPermissions: permissionGrantService => {
                'ngInject';
                return permissionGrantService.getAllClaimPermissions();
            },
            permissionDescriptions: permissionGrantService => {
                'ngInject';
                return permissionGrantService.retrievePermissionDescriptions();
            }
        },
        data: {
            pageHeader: "Permission Grants"
        }
    }
}];

export const SecurityRoutingModule = angular
    .module("apex.mainApp.security.routing", [])
    .run(configureStates(routes))
    .name;
